import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-in-flight-spinner',
  templateUrl: './in-flight-spinner.component.html',
  styleUrls: ['./in-flight-spinner.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatProgressSpinnerModule
  ]
})
export class InFlightSpinnerComponent {
  @Input() fullSize = false;
  @Input() diameter = 40;
  @Input() stroke = 3;
}
